/**
 * Returns the file name without its extension
 * @param {string} fileName name of file
 * @returns {string} file name without extension
 */
export const getFileBasename = (fileName: string): string => {
  return fileName.replace(/\.[^/.]+$/, '');
};
